var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisaPayment = function SvgVisaPayment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.933 18.998h-2.67l1.67-9.696h2.671L17.934 19Zm9.683-9.458a7 7 0 0 0-2.396-.413c-2.638 0-4.495 1.32-4.507 3.208-.022 1.392 1.33 2.166 2.341 2.63 1.034.475 1.385.784 1.385 1.207-.01.65-.835.95-1.604.95-1.067 0-1.638-.155-2.507-.517l-.351-.154-.374 2.176c.627.268 1.78.506 2.979.516 2.803 0 4.627-1.3 4.649-3.311.01-1.104-.703-1.95-2.242-2.64-.934-.444-1.506-.744-1.506-1.197.01-.413.483-.836 1.538-.836a4.8 4.8 0 0 1 1.99.371l.241.103z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M32.396 9.302h2.066l2.155 9.696h-2.473s-.242-1.114-.319-1.454h-3.429l-.56 1.454h-2.803L31 10.107c.275-.63.76-.805 1.396-.805m-.164 3.549s-.846 2.156-1.066 2.713h2.22c-.11-.485-.616-2.806-.616-2.806l-.186-.835c-.079.215-.193.51-.27.71zM3.688 9.303h4.298c.583.02 1.055.195 1.209.815l.933 4.449.002.006.286 1.341 2.615-6.611h2.825l-4.198 9.685H8.832l-2.38-8.424a11.3 11.3 0 0 0-2.808-1.065z",
    clipRule: "evenodd"
  })));
};
export default SvgVisaPayment;